import { render, staticRenderFns } from "./manifestPublic.vue?vue&type=template&id=90d62200&"
import script from "./manifestPublic.vue?vue&type=script&lang=js&"
export * from "./manifestPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports